<template>
  <div class="ontag">
    <div class="ontag__content">
      <div>
        <span
          v-if="id || handleTask"
          class="h1">
          Tasks for budget and event
        </span>
        <span
          v-else
          class="h1">
          Combined tasks for event and budget
        </span>
        <span
          v-if="isLoading"
          class="element--is-loading"></span>
      </div>
      <template v-if="combinedTodos && !isLoading">
        <template v-if="(id || handleTask) && combinedTodo">
          <a @click="showNone"> &lt; Back to list </a>
          <section>
            <card
              :info="cardInfo"
              :isLoading="isLoading" />
            <h3>Budget</h3>
            <table class="budgetTable">
              <thead>
                <th>Year</th>
                <th>Month</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Currency</th>
              </thead>
              <tr
                v-for="(budget, i) in combinedTodo.budgets"
                v-bind:key="i">
                <td>{{ budget.year }}</td>
                <td>{{ budget.month }}</td>
                <td>{{ budget.type }}</td>
                <td>{{ budget.value }}</td>
                <td>{{ budget.currency }}</td>
              </tr>
            </table>
            <h3>Event</h3>
            <table class="eventTable">
              <thead>
                <th>Eventline</th>
                <th>Task</th>
                <th>Eventdate</th>
                <th>Event Type</th>
                <th>Currency</th>
                <th>Description</th>
                <th>Unitprice</th>
                <th>Unit of measurment</th>
                <th>Quantity</th>
                <th>Invoice amount</th>
                <th>Revenue amount</th>
              </thead>
              <tr
                v-for="(event, i) in combinedTodo.events"
                v-bind:key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ event.task }}</td>
                <td>{{ event.eventDateText }}</td>
                <td>{{ event.eventType }}</td>
                <td>{{ event.currency }}</td>
                <td>{{ event.description }}</td>
                <td>{{ event.unitCustomerPrice }}</td>
                <td>{{ event.unitOfMeasure }}</td>
                <td>{{ event.quantity }}</td>
                <td>{{ event.invoiceAmount }}</td>
                <td>{{ event.revenueAmount }}</td>
              </tr>
            </table>
            <p>TE order comment</p>
            <textarea
              v-if="combinedTodo.teComment"
              disabled
              v-model="combinedTodo.teComment"></textarea>
            <br />
            <br />
            <label>Comment (Mandatory input if Delete or Pause)</label>
            <br />
            <textarea v-model="combinedTodo.comment"></textarea>
            <br />
            <p v-if="combinedTodo.doneDate">
              Task set to done: {{ combinedTodo.doneDate }} by
              {{ combinedTodo.doneBy }}
            </p>
            <p v-if="combinedTodo.pausedDate">
              Task paused: {{ combinedTodo.pausedDate }} by
              {{ combinedTodo.pausedBy }}
            </p>
            <p v-if="combinedTodo.deletedDate">
              Task deleted: {{ combinedTodo.deletedDate }} by
              {{ combinedTodo.deletedBy }}
            </p>
            <p v-if="combinedTodo.cancelDate">
              Task cancelled: {{ combinedTodo.cancelDate }}
            </p>
            <template v-if="combinedTodo.externalId">
              <div class="input-group--inline">
                <a @click="showNone"> &lt; Previous </a>
                <base-button
                  class="button--background-gray-dark"
                  @click="showNone"
                  text="Cancel">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="setDisabledPauseButton()"
                  @click="setTodoStatus('Paused')"
                  :text="
                    'Pause' +
                    (index < combinedTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="setDisabledDeleteButton()"
                  @click="setTodoStatus('Deleted')"
                  :text="
                    'Delete' +
                    (index < combinedTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-red"
                  @click="setTodoStatus('To do')"
                  :disabled="setDisabledTodoButton()"
                  :text="
                    'Set as todo' +
                    (index < combinedTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-blue"
                  :disabled="setDisabledDoneButton()"
                  @click="setTodoStatus('Done')"
                  :text="
                    'Done' +
                    (index < combinedTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
              </div>
            </template>
          </section>
        </template>
        <template v-else-if="combinedTodos && !isLoading">
          <section class="todos_top-container">
            <input
              type="text"
              placeholder="Search"
              v-model="searchQuery" />
            <base-button
              :disabled="isLoading"
              text="Handle tasks"
              @click="handleTasks(0)">
            </base-button>
            <card :info="totalCardInfo" />
            <div class="todos_top-container__showShipped">
              <input
                type="checkbox"
                id="showShipped"
                v-model="showShipped" />
              <label for="showShipped">{{ $t('showOnlyShipped') }}</label>
            </div>
          </section>
          <table>
            <thead>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Status"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'status')"
                  :options="filterValues('status')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Projectnumber"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'terpId')"
                  :options="filterValues('terpId')">
                </multi-select>
              </th>
              <th>Customer</th>
              <th>Club name</th>
              <th>Order no.</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueMonth')"
                  :options="filterValues('revenueMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueYear')"
                  :options="filterValues('revenueYear')">
                </multi-select>
              </th>
              <th>Revenue</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costMonth')"
                  :options="filterValues('costMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costYear')"
                  :options="filterValues('costYear')">
                </multi-select>
              </th>
              <th>Cost</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Last updated"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'lastUpdateBy')"
                  :options="filterValues('lastUpdateBy')">
                </multi-select>
              </th>
              <th></th>
            </thead>
            <tr
              v-for="(combinedTodo, i) in combinedTodos"
              v-bind:key="i">
              <td>{{ combinedTodo.status }}</td>
              <td>{{ combinedTodo.terpId }}</td>
              <td>{{ combinedTodo.customer }}</td>
              <td>{{ combinedTodo.clubName }}</td>
              <td>{{ combinedTodo.orderNumber }}</td>
              <td>{{ combinedTodo.revenueMonth }}</td>
              <td>{{ combinedTodo.revenueYear }}</td>
              <td>{{ combinedTodo.revenue }}</td>
              <td>{{ combinedTodo.costMonth }}</td>
              <td>{{ combinedTodo.costYear }}</td>
              <td>{{ combinedTodo.cost }}</td>
              <td>
                {{
                  combinedTodo.lastChanged == '' ||
                  combinedTodo.lastChangedBy == ''
                    ? ''
                    : combinedTodo.lastChanged +
                      ' by ' +
                      combinedTodo.lastChangedBy
                }}
              </td>
              <td @click="handleCombinedTodo(combinedTodo.externalId, i)">
                <use-svg
                  svg="arrow-right"
                  class="svg--90-negative" />
              </td>
            </tr>
          </table>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import MultiSelect from '@/components/form-elements/multi-select';
import UseSvg from '@/components/use-svg';
import Card from '@/components/info/card.vue';

export default {
  name: 'Combined',
  components: {
    BaseButton,
    MultiSelect,
    UseSvg,
    Card,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      filter: {
        status: ['Paused', 'To do'],
        terpId: [],
        revenueMonth: [],
        revenueYear: [],
        costMonth: [],
        costYear: [],
        lastUpdateBy: [],
      },
      isLoading: true,
      sortBy: 'changedDate',
      handleTask: false,
      showShipped: false,
      index: 0,
      searchQuery: '',
    };
  },
  watch: {
    id: {
      immediate: true,
      async handler(newId) {
        if (newId) {
          await this.$store.dispatch('todo/getCombinedTodo', { id: newId });
        } else {
          this.showNone();
        }
      },
    },
  },
  computed: {
    _combinedTodos() {
      return this.$store.getters['todo/combinedTodos'];
    },
    combinedTodo() {
      return this.$store.getters['todo/combinedTodo'];
    },
    cardInfo() {
      return [
        { id: 1, label: 'Status:', value: this.combinedTodo.status },
        { id: 2, label: 'Order no.:', value: this.combinedTodo.orderNumber },
        {
          id: 3,
          label: 'Customer in TERP:',
          value: this.combinedTodo.customer,
        },
        { id: 4, label: 'Club name:', value: this.combinedTodo.clubName },
        {
          id: 5,
          label: 'Project no. in TERP:',
          value: this.combinedTodo.terpId,
        },
      ];
    },
    totalCardInfo() {
      return [
        {
          id: 1,
          label: 'No of events in list:',
          value: this.combinedTodos.length,
        },
        {
          id: 2,
          label: 'Sum of revenue in the list:',
          value: `${this.sumOfRevenue()} kr`,
        },
        {
          id: 3,
          label: 'Sum of cost in the list:',
          value: `${this.sumOfCost()} kr`,
        },
      ];
    },
    combinedTodos() {
      let ct = this._combinedTodos;
      for (let f of Object.keys(this.filter)) {
        if (this.filter[f].length > 0) {
          ct = ct.filter(a => {
            return this.filter[f].includes(a[f]);
          });
        }
      }

      if (this.showShipped) {
        ct = ct.filter(a => a.isShipped);
      }

      if (this.searchQuery) {
        const searchLower = this.searchQuery.toLowerCase();
        ct = ct.filter(todo =>
          Object.values(todo).some(value =>
            value.toString().toLowerCase().includes(searchLower)
          )
        );
      }

      return ct.sort((a, b) =>
        this.sortBy in a
          ? this.sortBy in b
            ? a[this.sortBy] > b[this.sortBy]
              ? 1
              : -1
            : 1
          : -1
      );
    },
  },
  async mounted() {
    this.isLoading = true;
    if (!this.id && !this._combinedTodos.length) {
      await this.$store.dispatch('todo/getCombinedTodos');
    }
    this.isLoading = false;
  },
  methods: {
    handleTasks(index) {
      if (index < this.combinedTodos.length - 1) {
        this.showCombinedTodo(this.combinedTodos[index].externalId, index);
        this.handleTask = true;
      } else {
        this.showCombinedTodo(this.combinedTodos[index].externalId, index);
        this.handleTask = false;
        this.$store.dispatch('todo/getCombinedTodos');
      }
    },
    timeFormat(d) {
      if (!d) {
        return;
      }

      d = new Date(d);
      const locale = this.$i18n.locale; // Get the current i18n locale

      // Format the date according to the current locale
      const formattedDate = d.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });

      // Format the time
      const formattedTime = d.toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Adjust according to your locale preferences
      });

      // Combine and return the formatted date and time
      return `${formattedDate}, ${formattedTime}`;
    },
    setTodoStatus(status) {
      this.isLoading = true;
      this.$store
        .dispatch('todo/patchCombinedTodo', {
          id: this.combinedTodo.externalId,
          status: status,
          comment: this.combinedTodo.comment,
        })
        .then(() => {
          if (this.handleTask && this.index < this.combinedTodos.length - 1) {
            this.index += 1;
            this.handleTasks(this.index);
          } else {
            this.showNone();
          }
        });
      this.isLoading = false;
    },
    sumOfRevenue() {
      if (this.combinedTodos) {
        let myArray = this.combinedTodos.map(revenues => revenues.revenue);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    sumOfCost() {
      if (this.combinedTodos) {
        let myArray = this.combinedTodos.map(costs => costs.cost);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    showCombinedTodo(id, index) {
      this.$store.dispatch('todo/getCombinedTodo', { id: id });
      this.index = index;
    },
    handleCombinedTodo(id, i) {
      this.$router.push({ name: 'todo-combined', params: { id: id } });
    },

    setDisabledDeleteButton() {
      let status = this.combinedTodo.status.toLowerCase();
      if (
        status === 'deleted' ||
        status === 'cancelled' ||
        !this.combinedTodo.comment
      ) {
        return true;
      }
    },
    setDisabledPauseButton() {
      let status = this.combinedTodo.status.toLowerCase();
      if (
        status === 'cancelled' ||
        status === 'paused' ||
        !this.combinedTodo.comment
      ) {
        return true;
      }
    },
    setDisabledDoneButton() {
      let status = this.combinedTodo.status.toLowerCase();
      if (status === 'done' || status === 'cancelled') {
        return true;
      }
    },
    setDisabledTodoButton() {
      let status = this.combinedTodo.status.toLowerCase();
      if (
        status === 'to do' ||
        status === 'cancelled' ||
        !this.combinedTodo.comment
      ) {
        return true;
      }
    },
    showNone() {
      this.combinedTodo.externalId = '';
      this.handleTask = false;
      this.index = 0;
      if (this.id) {
        this.$router.push({ name: 'todo-combined' });
      }
    },
    filterValues(prop) {
      return [...new Set(this._combinedTodos.map(a => a[prop]))].map(a => {
        return {
          displayName: a === '' ? 'None' : a,
          value: a,
          checked: this.filter[prop].includes(a),
        };
      });
    },
    filterResults(e, prop) {
      this.filter[prop] = e.options
        .filter(option => option.checked)
        .map(o => o.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.todos_top-container {
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 12px;
  margin-bottom: 12px;

  button {
    width: 200px;
  }

  input {
    width: 200px;
  }

  &__showShipped {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      width: 20px;
      height: 20px;
    }
  }
}
table {
  border-collapse: collapse;
  table-layout: auto;
  width: auto;
  th {
    padding: 0.425rem 0.625rem;
    text-align: left;
    background-color: color(blue-light);
  }
  tr {
    &.pointer {
      cursor: auto;
    }
    &:nth-child(even) {
      background-color: color(gray-lighter);
    }
    &.checked {
      background-color: color(blue-light);
    }
  }
  td {
    padding: 0.625rem;
    &:last-child {
      padding-right: 0;
      cursor: pointer;
    }
  }
}
.budgetTable {
  width: 50%;
}
.eventTable {
  width: 100%;
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
  margin-bottom: 20px;
}
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.ontag {
  flex-grow: 1;
  width: 100%;
  @include media('small') {
    width: calc((100% / 2) - (1rem * 1));
  }
  @include media('large') {
    width: calc((100% / 3) - (1rem * 2));
  }
}
.ontag__content {
  background-color: color(white);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  &.dashboard {
    background-color: transparent;
    border-radius: 0;
  }
}
.input-group--inline {
  button {
    margin: 0.5rem;
  }
}
</style>
